<template>
  <el-popover
    trigger="click"
    @show="searchClick"
    placement="right-start">
    <div v-if="!isZipCode" slot="reference">
      <slot></slot>
    </div>

    <el-input size="mini" v-model="searchCode" @input="searchInput" clearable @clear="handleClear" placeholder="请输入搜索">
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <el-tree
      v-loading="loading"
      :data="treeList"
      node-key="id"
      default-expand-all
      @node-click="handleNodeClick"
      style="margin-top: 10px;max-height: 300px;overflow-y: scroll">
    </el-tree>
  </el-popover>
</template>

<script>
import {debounce} from "my-tools-kit";
import {deepCopy} from "iview/src/utils/assist";

export default {
  name: "regionFilter",
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isZipCode: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'header'
    }
  },
  data() {
    return {
      searchCode: '',
      totalList: [],
      treeList: [],
      loading: false
    }
  },
  watch: {
    list(val) {
      this.totalList = this.formatVal(val)
      this.treeList = deepCopy(this.totalList)
      this.loading = false
    }
  },
  methods: {
    searchClick() {
      this.searchInput()
      this.loading = true
      this.$emit('handleFilter')
    },
    formatVal(list) {
      return list.map(item => {
        let o = {
          children: [],
          label: item.regionName,
          id: item.id
        }
        item.regionDetail.forEach(e => {
          let child = {
            label: e,
            id: e
          }
          o.children.push(child)
        })
        return o
      })
    },
    searchInput:debounce(function () {
      if (!this.searchCode) {
        this.handleClear()
      }
      const total = deepCopy(this.totalList)
      let list = []
      list = total.filter(item => {
        return item.children.some(e => e.label.includes(this.searchCode))
      })
      list.forEach(item => {
        item.children = item.children.filter(code => code.label.includes(this.searchCode))
      })
      this.treeList = list
    }, 500, false),
    handleNodeClick(node, pNode) {
      if (node.children) return
      this.searchCode = node.label
      this.$emit('search', node.label, pNode.parent.data.label, this.type)
    },
    handleClear() {
      this.treeList = deepCopy(this.totalList)
      this.$emit('clear', this.type)
    }
  }
}
</script>

<style scoped lang="less">
.el-button {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/regionFilter.vue